module.exports = "<h1 ng-bind-html=\"myLabel\"\n  class=\"{{myStyle}}\"\n  ng-class=\"{'strong-text': enableStrong}\"\n  ng-if=\"myLevel === 1 || (myLevel !== 1 && myLevel !== 2 && myLevel !== 3)\">\n</h1>\n<h2 ng-bind-html=\"myLabel\"\n  class=\"{{myStyle}}\"\n  ng-class=\"{'strong-text': enableStrong}\"\n  ng-if=\"myLevel === 2\">\n</h2>\n<h3 ng-bind-html=\"myLabel\"\n  class=\"{{myStyle}}\"\n  ng-class=\"{'strong-text': enableStrong}\"\n  ng-if=\"myLevel === 3\">\n</h3>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/global/directives/titles/myTitle.html
// module id = 1248
// module chunks = 0